@if (thuisverzorgersPage) {
  <mat-nav-list>
    <h3 class="subheader">
      Thuisverzorgers
      @if (!thuisverzorgersPage.isEmpty()) {
        <zah-sort-button
          [sortOrder]="initialPageRequest.getSortOrder()"
          (sortOrderChange)="onSortOrderChange($event)">
        </zah-sort-button>
      }
    </h3>
    @for (thuisverzorger of thuisverzorgersPage.getItems(); track thuisverzorger) {
      <mat-list-item (click)="onThuisverzorgerClick(thuisverzorger)">
        <zah-avatar matListItemAvatar [name]="thuisverzorger.getNaam()"></zah-avatar>
        <div matListItemTitle>{{thuisverzorger.getNaam()}} <span class="mat-small">({{thuisverzorger.getPersoneelsnummer()}})</span></div>
        <div matListItemLine class="mat-small">{{thuisverzorger.getEmail()}}</div>
        <div matListItemLine class="mat-small">{{thuisverzorger.getDiensten() | zahThuisverzorgerDiensten:diensten:zones}}</div>
        <button matListItemMeta
          disableRipple="true"
          class="center-vertically"
          mat-icon-button
          (click)="$event.stopPropagation(); onDeleteClick(thuisverzorger)">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </mat-list-item>
      <mat-divider></mat-divider>
    }
    @if (thuisverzorgersPage.isEmpty()) {
      <mat-list-item
        class="no-list-item-highlight"
        disableRipple>
        <div matListItemTitle>Geen thuisverzorgers gevonden</div>
      </mat-list-item>
    }
    <mat-list-item class="no-list-item-highlight"
      disableRipple
      lines="3">
      <span matListItemMeta class="center-vertically">
        <button mat-mini-fab
          color="accent"
          (click)="onAddClick()">
          <mat-icon>add</mat-icon>
        </button>
      </span>
    </mat-list-item>
  </mat-nav-list>
  @if (!thuisverzorgersPage.isEmpty()) {
    <zah-paginator
      [currentPage]="thuisverzorgersPage"
      [pageSize]="initialPageRequest.getPageSize()"
      (pageSizeChange)="onPageSizeChange($event)"
      (pageChange)="onPageChange($event)">
    </zah-paginator>
  }
}
